import { Breadcrumb, DetailCard, DetailTitle, Layout, ListTitle, MTools } from '@/components';
import { imagePrefix } from '@/constants';
import { IBbs } from '@/models/types/bbs';
import { getBbsList } from '@/services/api';
import moment from 'moment';
import React from 'react';
import { useEffect } from 'react';
import { useState } from 'react';
import playIcon from '@/assets/image/play.png';
import styles from './index.less';
import { RouteComponentProps, withRouter } from 'dva/router';

interface IForumProps {

}

const Forum: React.FC<IForumProps & RouteComponentProps> = ({ history }) => {
  const [data, setData] = useState<IBbs>()
  const [list, setList] = useState<IBbs[]>([])

  useEffect(() => {
    getData()
    getList()
  }, [])
  const getData = async () => {
    const result = await getBbsList('1')
    console.log(result)
    if (result.success) {
      setData(result.data[0])
    } else {
      MTools.Tips('error', (result && (result.message)) || '系统异常，请刷新再试')
    }
  }

  const getList = async () => {
    const result = await getBbsList('2')
    if (result.success) {
      setList(result.data)
    } else {
      MTools.Tips('error', (result && (result.message)) || '系统异常，请刷新再试')
    }
  }


  const getTime = (startTime?: string, endTime?: string) => {
    if (!startTime || !endTime) return
    return `${moment(startTime, 'YYYY-MM-DD HH:mm:ss').format('YYYY年MM月DD日 HH:mm')}`//-${moment(endTime, 'YYYY-MM-DD HH:mm:ss').format('HH:mm')}`
  }

  return (
    <div className={styles.index}>
      <Layout
        padding={0}
      >
        <div
          className={styles.main}
          style={{
            backgroundImage: `url(${imagePrefix('bbs.png')})`
          }}
        >
          <div className={styles.breadcrumb}>
            <Breadcrumb
              data={[
                { title: "论坛" }
              ]}
            ></Breadcrumb>
          </div>
          <div className={styles.title}>
            {data?.title}
          </div>
          <div
            onClick={() => {
              if (data?.id) {
                history.push(`/app/forum/detail/${data?.id}`)
              }
            }}
            className={styles.cover}
            style={{
              backgroundImage: `url(${data?.cover})`
            }}
          >
            <div className={styles.icon}>
              <img src={playIcon} alt="" />
            </div>
          </div>
          <div className={styles.time}>
            {getTime(data?.startTime, data?.endTime)}
          </div>
        </div>
        <div className={styles.summary}>
          <DetailTitle title='主论坛简介'></DetailTitle>
          <div className={styles.text}>
            {data?.summary}
          </div>
        </div>
        <div className={styles.bbsList}>
          <DetailTitle title='分论坛'></DetailTitle>
          <div className={styles.list}>
            {list?.map(item => {
              return (
                <div
                  className={styles.item}
                  key={item.id}
                  onClick={() => {
                    MTools.Url.gotoUrl(`/app/forum/detail/${item.id}`)
                  }}
                >
                  <DetailCard item={{
                    title: item.title,
                    cover: item.cover,
                    vipId: getTime(item.startTime, item.endTime) || ''
                  }}></DetailCard>
                </div>
              )
            })}
          </div>
        </div>
      </Layout>
    </div>
  );
};

export default withRouter(Forum);